// SCR-006's route (NAV-005 Invoices, was "Billing periods"), composed into the route table by
// TASK-140. The invoice detail route (`/customers/:orgId/invoices/:period`, SCR-007) is the
// invoice module's: it composes this module's `LedgerInvoice` panel (ledger-invoice.tsx) with its
// own customer-invoice and statement panels.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { Periods } from "./periods";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-005", path: "/invoices", title: "Invoices", permission: "billing:read", component: Periods }),
];
